import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as WarehouseActions from '../_actions/warehouse';
import { Warehouse } from '../_models';

export interface WarehouseState extends EntityState<Warehouse> {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<Warehouse> = createEntityAdapter<Warehouse>();

const initialState: WarehouseState = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

const warehouseReducer = createReducer(
  initialState,

  on(WarehouseActions.loadWarehouses, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(WarehouseActions.loadWarehousesSuccess, (state, { warehouses }) =>
    adapter.setAll(warehouses, { ...state, loaded: true, loading: false })
  ),

  on(WarehouseActions.loadWarehousesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  on(WarehouseActions.addWarehouseSuccess, (state, { warehouse }) =>
    adapter.addOne(warehouse, state)
  ),

  on(WarehouseActions.updateWarehouseSuccess, (state, { warehouse }) =>
    adapter.upsertOne(warehouse, state)
  ),

  on(WarehouseActions.deleteWarehouseSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    WarehouseActions.addWarehouseFailure,
    WarehouseActions.updateWarehouseFailure,
    WarehouseActions.deleteWarehouseFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: WarehouseState | undefined, action: Action) {
  return warehouseReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
